import apiClient from './apiClient';

export const voiceAssistantApi = {
  // Einstellungen
  getSettings: () => apiClient.get('/voice-assistant/settings').then(r => r.data),
  updateSettings: (settings) => apiClient.put('/voice-assistant/settings', settings).then(r => r.data),

  // Status
  getStatus: () => apiClient.get('/voice-assistant/status').then(r => r.data),

  // Nummernsuche + Provisioning
  searchAvailableNumbers: (areaCode = '2365', limit = 20) =>
    apiClient.get('/voice-assistant/available-numbers', { params: { areaCode, limit } }).then(r => r.data),
  provision: (phoneNumber = null) =>
    apiClient.post('/voice-assistant/provision', phoneNumber ? { phoneNumber } : {}).then(r => r.data),
  deprovision: () => apiClient.delete('/voice-assistant/provision').then(r => r.data),

  // Call Logs
  getCallLogs: (params = {}) => apiClient.get('/voice-assistant/call-logs', { params }).then(r => r.data),
  getCallLog: (callId) => apiClient.get(`/voice-assistant/call-logs/${callId}`).then(r => r.data),
  syncCalls: () => apiClient.post('/voice-assistant/sync-calls').then(r => r.data),

  // Prompt generieren (basierend auf Firmendaten)
  generatePrompt: () => apiClient.post('/voice-assistant/generate-prompt').then(r => r.data),

  // Test
  testConnection: () => apiClient.post('/voice-assistant/test').then(r => r.data),

  // Regulatory Compliance (für deutsche Telefonnummern)
  getRegulatoryStatus: (forceRefresh = false) => {
    const params = forceRefresh ? { _t: Date.now() } : {};
    return apiClient.get('/voice-assistant/regulatory-status', {
      params,
      headers: forceRefresh ? { 'Cache-Control': 'no-cache' } : {}
    }).then(r => r.data);
  },

  uploadRegulatoryDocument: (documentType, file) => {
    const formData = new FormData();
    formData.append('document', file);
    formData.append('documentType', documentType);
    return apiClient.post('/voice-assistant/regulatory-documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data);
  },

  submitRegulatoryBundle: () => apiClient.post('/voice-assistant/regulatory-submit').then(r => r.data)
};
